import {
  getGetControlResultListPaginatedQueryKey,
  getGetControlResultQueryKey,
  useUpdateControlResultPriority,
} from "@/spz-api/control-results/control-results";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import type { PriorityOption } from "../components/priority-selector";

export const useChangeControlResultPriority = (
  controlId: string,
  resultId: string,
) => {
  const queryClient = useQueryClient();

  const { mutate: updateControlResultPriority } =
    useUpdateControlResultPriority({
      mutation: {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: getGetControlResultQueryKey(controlId, resultId),
          });
          queryClient.invalidateQueries({
            queryKey: getGetControlResultListPaginatedQueryKey(controlId),
          });
        },
        onError: () => {},
      },
    });

  const handlePriorityChange = useCallback(
    (priority: PriorityOption) => {
      updateControlResultPriority({
        controlId,
        resultId,
        data: {
          priorityId: priority.value,
        },
      });
    },
    [updateControlResultPriority, controlId, resultId],
  );

  return { handlePriorityChange };
};
